import { FormattedMessage } from "react-intl";
import { getDaysRemaining } from "../timeHelper.tsx";
import useTermOptDeadline from "../useTermOptDeadline.tsx";

export default function DaysRemainingMessage({
  type,
}: {
  type: "program-choice" | "decision";
}) {
  const { optDeadline } = useTermOptDeadline();

  if (!optDeadline) {
    return null;
  }

  const count = getDaysRemaining(optDeadline);

  if (type === "program-choice") {
    return (
      <FormattedMessage
        defaultMessage="{count, plural, =0 {Today is the last day to update your program choice.} =1 {You have 1 day to update your program choice.} other {You have # days to update your program choice.}}"
        values={{
          count,
        }}
      />
    );
  }

  return (
    <FormattedMessage
      defaultMessage={
        "{count, plural, =0 {Today is the last day to change your decision.} =1 {You have 1 day to change your decision.} other {You have # days to change your decision.}}"
      }
      values={{ count }}
    />
  );
}
